import service1 from "../../assets/images/webp/OurProjects_img.jpg"; // replace with actual paths
import service2 from "../../assets/images/webp/OurProjects_img.jpg";
import service3 from "../../assets/images/webp/OurProjects_img.jpg";
import service4 from "../../assets/images/webp/OurProjects_img.jpg";
import service5 from "../../assets/images/webp/OurProjects_img.jpg";
import service6 from "../../assets/images/webp/OurProjects_img.jpg";
import service7 from "../../assets/images/webp/OurProjects_img.jpg";
import service8 from "../../assets/images/webp/OurProjects_img.jpg";
import React, { useEffect } from "react";
import { gsap } from "gsap";
import "../../styles/adv.css";

const ServicesHero = () => {
  useEffect(() => {
    const timeline = document.querySelector(".timeline");
    const timelineDiv = document.querySelector(".timeline-div");
    const timelineItems = document.querySelectorAll(".timeline-item");

    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      let activeItemIndex = -1;

      // Check which item is currently active based on the scroll position
      timelineItems.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.top + itemRect.height / 2;

        // Check if the item is in the viewport
        if (itemCenter >= 0 && itemCenter <= windowHeight) {
          if (activeItemIndex !== index) {
            gsap.to(item, {
              scale: 1.1,
              opacity: 1,
              duration: 0.5,
              ease: "power3.out",
              overwrite: true,
            });
            activeItemIndex = index;
          }
        }
      });

      // Calculate scroll percentage
      const scrollHeight = window.scrollY;
      const documentHeight =
        document.documentElement.scrollHeight - windowHeight;
      const scrollPercentage = scrollHeight
        ? (scrollHeight / documentHeight) * 100
        : 0;

      // Only calculate for the active item
      if (timeline && activeItemIndex >= 0) {
        const activeItem = timelineItems[activeItemIndex];
        const itemRect = activeItem.getBoundingClientRect();
        const itemHeight = itemRect.height;
        const itemOffsetTop = activeItem.offsetTop;

        // Calculate scroll progress relative to the active item
        const scrollRelativeToActive = Math.min(
          (scrollHeight - itemOffsetTop) / itemHeight,
          1
        );

        // Calculate the height of the timeline's line, using scroll progress relative to the active item
        const lineHeight =
          (activeItemIndex + scrollRelativeToActive) *
          (100 / timelineItems.length);

        gsap.to(timeline, {
          "--timeline-before-height": `${lineHeight}%`,
          duration: 0.5,
          ease: "power3.out",
        });

        // Set the height of timeline-div before the active item only (not including next item)
        const timelineDivHeight =
          (activeItemIndex + scrollRelativeToActive) *
          (100 / timelineItems.length);

        console.log("timelineDivHeight", timelineDivHeight);
        console.log("timelineItems", timelineItems.length);

        // Update the timeline-div height dynamically based on the active item only
        gsap.to(timelineDiv, {
          "--timeline-div-before-height": `${timelineDivHeight}%`,
          duration: 0.5,
          ease: "power3.out",
        });

        // Apply the gradient to the timeline line (for smooth scrolling)
        const nextItem = timelineItems[activeItemIndex + 1];

        if (nextItem) {
          const gradientStart =
            (activeItemIndex + scrollRelativeToActive) *
            (100 / timelineItems.length);
          const gradientEnd =
            (activeItemIndex + 1 + scrollRelativeToActive) *
            (100 / timelineItems.length);

          gsap.to(timeline, {
            "--timeline-gradient": `linear-gradient(180deg, #ef4444 ${gradientStart}%, #991b1b ${gradientEnd}%, #3b82f6 ${gradientEnd}%, rgba(248, 250, 252, 0.35))`,
            duration: 0.5,
            ease: "power3.out",
          });
        } else {
          // Final segment of the timeline line if it's the last item
          gsap.to(timeline, {
            "--timeline-gradient": `linear-gradient(180deg, #ef4444 100%, #991b1b 100%, #3b82f6 100%, rgba(248, 250, 252, 0.35))`,
            duration: 0.5,
            ease: "power3.out",
          });
        }
      }

      // Animate other items to reduce scale and opacity when they are not active
      timelineItems.forEach((item, index) => {
        if (index !== activeItemIndex) {
          gsap.to(item, {
            scale: 1,
            opacity: 0.5,
            duration: 0.5,
            ease: "power3.out",
            overwrite: true,
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check on page load

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="bg_hero_s">
      <div className=" pb-5">
        <div className="container">
          <div className=" pt-5">
            <h1 className=" text-center fs_44 ff_s fw-bold" style={{ color: "#f8fafc" }}>
              Our Services
            </h1>
            <p
              className="text-center text_op_56 fs_16 mx-auto max_w_472"
              style={{ color: "rgba(248, 250, 252, 0.68)" }}
            >
              The Media Matrix App stands out as a transformative platform for
              the Indian media and entertainment industry. Here's why it's the
              ultimate choice:
            </p>
          </div>

          <div className="container">
            <div className="pb-5" style={{ paddingTop: "30px" }}>
              <div className="timeline-div position-relative">
                <div className="timeline mb-0 mt-0">
                  {/* Strategic Event Planning */}
                  <div className="timeline-item">
                    <div className="timeline-content text-start">
                      <div className="d-flex align-items-center gap-3 flex-row-reverse">
                        <div>
                          <h4 className=" fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Strategic Event Planning
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              End-to-end event ideation & blueprinting
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Campaign integration & theme planning
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Venue Scouting & Management */}
                  <div className="timeline-item">
                    <div className="timeline-content">
                      <div className="d-flex align-items-center gap-3">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Venue Scouting & Management
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Location hunt & feasibility
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Permissions, layouts, and vendor alignments
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Luxury Hospitality & F&B */}
                  <div className="timeline-item">
                    <div className="timeline-content text-start">
                      <div className="d-flex align-items-center gap-3 flex-row-reverse">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Luxury Hospitality & F&B
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Curated catering menus
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Guest flow & hosting team
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Artist Booking & Live Engagement */}
                  <div className="timeline-item">
                    <div className="timeline-content">
                      <div className="d-flex align-items-center gap-3">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Artist Booking & Live Engagement
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Celebrity onboarding
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Performance & audience interaction planning
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* PR, Promotion & Buzz Building */}
                  <div className="timeline-item">
                    <div className="timeline-content text-start">
                      <div className="d-flex align-items-center gap-3 flex-row-reverse">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            PR, Promotion & Buzz Building
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Press, digital & on-ground buzz creation
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Influencer & media coverage
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* AV & Tech Command Center */}
                  <div className="timeline-item">
                    <div className="timeline-content">
                      <div className="d-flex align-items-center gap-3">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            AV & Tech Command Center
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Sound, lighting & LED walls
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              On-site control room management
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Design & Creative Fabrication */}
                  <div className="timeline-item">
                    <div className="timeline-content text-start">
                      <div className="d-flex align-items-center gap-3 flex-row-reverse">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Design & Creative Fabrication
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Event set, décor, props & theming
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Custom installations & backdrops
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Logistics & Field Operations */}
                  <div className="timeline-item">
                    <div className="timeline-content">
                      <div className="d-flex align-items-center gap-3">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Logistics & Field Operations
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Transport, security & permissions
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Ground staff & emergency handling
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* VVIP Guest & Show Run Support */}
                  <div className="timeline-item">
                    <div className="timeline-content text-start">
                      <div className="d-flex align-items-center gap-3 flex-row-reverse">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            VVIP Guest & Show Run Support
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Anchor scripts, flow control
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Green rooms, timing & run sheet ops
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Impact Reporting & Post-Event Wrap */}
                  <div className="timeline-item mb-0">
                    <div className="timeline-content">
                      <div className="d-flex align-items-center gap-3">
                        <div>
                          <h4 className="fs_23 fw-bold ff_n mb-0" style={{ color: "#f8fafc" }}>
                            Impact Reporting & Post-Event Wrap
                          </h4>
                          <ul
                            className="fs_20 mt-3 fw-normal ff_n ps-3 mb-0"
                            style={{ color: "rgba(248, 250, 252, 0.68)" }}
                          >
                            <li className=" fs_16 ff_p list_type">
                              Feedbacks, analytics & reports
                            </li>
                            <li className=" fs_16 ff_p list_type">
                              Thank-you notes & memory packaging
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesHero;
